import { useEffect, useState } from "react";
import ImageSimple from "../../../components/Button/ImageSimple";
import env from "../../../env";

function UploadImage(props) {
  const {
    content,
    sliderChange,
    setSliderChange,
    value,
    part,
    onUploadStatus,
  } = props;

  const [image, setImage] = useState(null);
  const [thumb, setThumb] = useState(null);
  const [, setImageUrl] = useState("");

  const uploadImage = async (file, uploadKey) => {
    if (!file) return;

    // شروع آپلود
    onUploadStatus?.(uploadKey, "uploading");

    try {
      const res = await fetch(env.siteApi + "/panel/user/upload", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          base64image: file.base64,
          imgName: file.fileName,
          folderName: "slider",
        }),
      });

      const result = await res.json();

      // اگر API خطا برگرداند
      if (!res.ok || result.error || !result.url) {
        throw new Error(result.error || "Upload failed");
      }

      setSliderChange((prev) => ({
        ...prev,
        [value]: result.url,
      }));

      // آپلود موفق
      onUploadStatus?.(uploadKey, "success");
    } catch (error) {
      console.log(error);

      // آپلود ناموفق
      onUploadStatus?.(uploadKey, "error");
    }
  };

  useEffect(() => {
    uploadImage(image, value);
  }, [image]);

  useEffect(() => {
    uploadImage(thumb, `${value}_thumb`);
  }, [thumb]);

  return (
    <div className="images">
      <ImageSimple
        cardName="Input Image"
        imageGallery={[]}
        setImage={setImage}
        setImageUrl={setImageUrl}
        setThumb={setThumb}
        part={part}
      />

      <img
        src={
          sliderChange?.[value]
            ? env.siteApiUrl + sliderChange[value]
            : content?.[value]
              ? env.siteApiUrl + content[value]
              : ""
        }
        alt={content?.title || env.default}
      />
    </div>
  );
}

export default UploadImage;
